import axios from 'axios';

// In production, served under /IdentiumFx/ subpath on identiumone.com
// In development, CRA proxy forwards /api to backend
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? '/IdentiumFx/api'
    : '/api'
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('fx_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('fx_token');
      localStorage.removeItem('fx_user');
      window.location.href = '/IdentiumFx/login';
    }
    return Promise.reject(err);
  }
);

export default api;
